import { PersonFieldsType } from "../../../api/types";

interface PersonsRankingProps {
  label: string;
  persons: (PersonFieldsType & {
    points: number;
  })[];
  pointLabel: string;
}

export const PersonsRanking = ({
  label,
  persons,
  pointLabel,
}: PersonsRankingProps) => {
  return (
    <div className="relative">
      <div className="bg-white shadow-md rounded-md overflow-hidden max-w-lg mx-auto mt-8 flex flex-col flex-1 w-full">
        <div className="bg-gray-200 py-2 px-4">
          <h2 className="text-xl font-semibold text-gray-800">{label}</h2>
        </div>
        <ul className="divide-y divide-gray-200">
          {persons?.map((item, index) => (
            <li key={item.id} className="flex items-center py-4 px-6">
              <span className="text-gray-700 text-lg font-medium mr-6">
                {index + 1}
              </span>
              {item.image?.[0]?.url ? (
                <img
                  className="w-16 h-16 rounded-full object-cover mr-4"
                  src={item.image?.[0]?.url}
                  alt={item.full_name}
                />
              ) : (
                <div className="w-16 h-16 mr-4 bg-gray-200 rounded-full" />
              )}
              <div className="flex-1">
                <h3 className="text-lg font-medium text-gray-800">
                  {item.full_name}
                </h3>
                <p className="text-gray-600 text-base">
                  <strong>#{item.number}</strong> • {item.points || 0}{" "}
                  {item.points > 1 ? pointLabel : pointLabel.slice(0, -1)}
                </p>
              </div>
              {item.team_logo?.[0]?.url ? (
                <img
                  className="w-12 h-12 object-contain"
                  src={item.team_logo?.[0]?.url}
                  alt={item.team?.[0]}
                />
              ) : (
                <div className="w-12 h-12 bg-gray-200 rounded-full" />
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
